module.exports = __webpack_public_path__ + "images/emoji/confetti_ball.28c0d41e32b2695531c3.png";